import React, { useState, useEffect, useContext, useRef } from "react"; /*st48236 - 508 compliance*/
import alertcircle from "../../assets/images/icons/alert-circle.svg";
import acrobat from "../../assets/images/icons/Acrobat.svg";
import { getApiService } from "../../services/ApiService";
import { Spinner } from "react-bootstrap";
import { GetPayLoad } from "../../services/PayLoadStorage";
import { LanguageContext } from "../../contexts/LanguageContext";

const Edelivery = () => {
	const Payload = GetPayLoad('PayLoad');
	const [isLoading, setLoading] = useState(true,);
	const { pageContent } = useContext(LanguageContext);
	const [genericContent, setGenericContent] = useState([]);
	const [edeliveryContent, setEDeliveryContent] = useState([]);
	const [edeliveryData, setEdeliveryData] = useState([]);
	const [errorFlag, setErrorFlag] = useState(false);
	const [isEdeliveryLoading, setEdeliveryLoading] = useState(true);
	const [showIframe, setShowIframe] = useState(true);
	const [docAvailable, setDocAvailable] = useState(false);
	const ref = useRef(null); //st48236 - 508 compliance
	const [isContentReady, setContentReady] = useState(false); // st48236 - 508 compliance Track when all API responses are received
	const [apiCallsCompleted, setApiCallsCompleted] = useState(false); // st48236 - 508 compliance Track when all API calls are completed
	//st48236 - 508 compliance

	const baseUrl = process.env.REACT_APP_API_BASE_URL;

	const handleClick = (url, docName, docType) => {
		const targetEDeliveryURl = baseUrl + process.env.REACT_APP_API_EDELIVERY_PDF_ENDPOINT;
		const form = document.createElement('form');
		form.method = 'POST';
		form.action = targetEDeliveryURl;
		form.target = '_blank'; // Open in a new tab
		const alfresco = url.includes('alfresco');

		const fields = {
			pdfurl: url,
			alfresco: alfresco,
			docname: docName,
			docType: docType,
			"X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
			"X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
			"X-Hps-Region": Payload?.region,
			"X-Hps-Site-Id": Payload?.site_cd,
		};
		for (const key in fields) {
			if (fields[key] !== undefined) {
				const input = document.createElement('input');
				input.type = 'hidden';
				input.name = key;
				input.value = fields[key];
				form.appendChild(input);
			}
		}

		document.body.appendChild(form);
		form.submit();
		document.body.removeChild(form); // Clean up the form after submission
	};

	const headers = {
		"X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
		"X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
		"X-Hps-Region": Payload?.region,
		"X-Hps-Site-Id": Payload?.site_cd,
	};

	useEffect(() => {

		if (pageContent?.edelivery) {
			setEDeliveryContent(pageContent.edelivery);
		}

		if (pageContent?.generic) {
			setGenericContent(pageContent.generic);
		}
	}, [pageContent]);

	useEffect(() => {
		const targetEDeliveryURl = process.env.REACT_APP_API_EDELIVERY_ENDPOINT;
		getApiService(baseUrl, targetEDeliveryURl, 
			{ 	cim: Payload?.cim, 
				case_num: Payload?.case_num, 
				carrier_code: Payload?.owning_carrier, 
				site_cd: Payload?.site_cd,
				bill_period: '' },
				headers)
			.then((response) => {
				setEdeliveryLoading(false);
				if (response?.data?.statusCode !== 200) {
					setErrorFlag(true);
				} else {
					setErrorFlag(false);
					const edeliveryDatas = JSON.parse(response.data.data);
					setEdeliveryData(edeliveryDatas);
					setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed 
					edeliveryDatas.serviceResponses.forEach((response) => {
						if (response.resultSets.length > 0) {
							setDocAvailable(true);
						}
					})
				}
			})
			.catch(error => {
				setErrorFlag(true);
				setEdeliveryLoading(false);
			});
	}, []);

	const [selectedDoc, setSelectedDoc] = useState(null);

	const handleCloseIframe = () => {
		setShowIframe(false);
	};

	const formatDate = (dateString) => {
		const [year, month, day] = dateString.split("-");
		return `${month}/${day}/${year}`;
	};


	/*st48236 - 508 compliance*/
	/*st48236 - 508 compliance*/
const [userInteracted, setUserInteracted] = useState(false);

useEffect(() => {
  const handleUserInteraction = () => {
    setUserInteracted(true);
  };

  // Listen for user interactions
  document.addEventListener('click', handleUserInteraction);
  document.addEventListener('keydown', handleUserInteraction);
  
  return () => {
    document.removeEventListener('click', handleUserInteraction);
    document.removeEventListener('keydown', handleUserInteraction);
  };
}, []);

useEffect(() => {
  let timeoutId;
  
  if (apiCallsCompleted && !isContentReady) {
    timeoutId = setTimeout(() => {
      setContentReady(true);
      
      // Only auto-focus if user hasn't interacted
      if (!userInteracted && ref.current) {
        requestAnimationFrame(() => {
          ref.current.focus({ preventScroll: true });
        });
      }
    }, parseInt(process.env.REACT_APP_READABILITY_TIMEOUT) || 100);
  }
  
  return () => {
    if (timeoutId) clearTimeout(timeoutId);
  };
}, [apiCallsCompleted, isContentReady, userInteracted]);
	  
	/*st48236 - 508 compliance*/

	return (
		<>
			<main
				role="main"
				tabIndex="-1" // Make the <main> tag focusable
				ref={ref} // Attach the ref to the <main> tag
				style={{ outline: 'none' }} // revmove border
				aria-label="Edelivery Page"
			> {/*st48236 - 508 compliance*/}
				<div>
					<div className="container-fluid content-inner mt-n5 py-0">
						<div className="row">
							<div className="col-md-12 col-xl-12">
								<div className="row">
									<div className="col-md-12">
										<div className="card" data-aos="fade-up" data-aos-delay="800">
											<div className="col-md-12 col-xl-12">
												<div className="row">
													<div className="" data-aos="fade-up" data-aos-delay="800">
														<div className="card-body mt-3 mb-4">
															<div id="d-main" className="rounded doc-edev">
																<div tabIndex={0} className="col-12 d-flex">
																	<i className="fe fe-alert-circle navy-icon"></i>
																	<span className="ms-2 fw-light">{edeliveryContent.edelivery_doc_coverage_and_rate_txt}</span>
																</div>
																<div tabIndex={0} className="col-12 mt-4 mb-3">
																	<h5 className="fw-semibold">{edeliveryContent.edelivery_document_case_number_text} {Payload?.case_num}</h5>
																</div>
																<div className="bd-example table-responsive mt-4 table-edev">
																	<table tabIndex={0} className="table table-striped">
																		<thead>
																			<tr>
																				<th scope="col" className="col-11">{edeliveryContent.edelivery_document_name_label}</th>
																				<th scope="col" className="col-1">{edeliveryContent.edelivery_revised_date_label}</th>
																			</tr>
																		</thead>
																		<tbody>
																			{isEdeliveryLoading && (
																				<div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
																					<Spinner animation="border" role="status" ></Spinner>
																					<div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
																				</div>
																			)}
																			{!isEdeliveryLoading && (
																				docAvailable ? (
																					edeliveryData?.serviceResponses.map((response, index) => (
																						<>
																							{response.resultSets.length !== 0 && !(Payload?.owning_carrier === 'Q5' && response.remoteSource !== "Alfresco API") ? (
																								<tr key={index}>
																									<td colSpan="2" className="fw-bold">{response.remoteSource == "Alfresco API" ? 'Alfresco' : "O'neil"}</td>
																								</tr>
																							) : null}
																							{response.resultSets.map((doc, docIndex) => (
																								<tr key={`${index}-${docIndex}`}>
																									<td>
																										{response.errors !== 0 && response.remoteSource == "Alfresco API" ? (
																											<a href="#" onClick={() => handleClick(doc.filePath, doc.docName, doc.docType, true)}  >
																												{doc.docType}
																											</a>) : response.errors !== 0 && response.remoteSource == "O'neil Web API" ? (
																												<a href="#" onClick={() => handleClick(doc.filePath, false)}  >
																													{doc.docName}
																												</a>
																											) : (
																											<span>{edeliveryContent.edelivery_no_records_found_text}</span>
																										)}
																									</td>
																									{response.errors !== 0 && response.remoteSource == "Alfresco API" ? (
																										<td>{doc.processedDate}</td>
																									) : (
																										<td>{formatDate(doc.processedDate)}</td>
																									)}

																								</tr>
																							))}
																						</>
																					))) : <tr>
																					<td colSpan="2" className="fw-bold">{edeliveryContent.edelivery_no_records_found_text}</td>
																				</tr>)}
																		</tbody>
																	</table>
																</div>
																{errorFlag && !isEdeliveryLoading && (
																	<div className="col-12 d-flex mt-4 mb-3">
																		<span className="ms-2 fw-light">{genericContent?.error_message}</span>
																	</div>
																)}
																<div className="col-12 d-flex mt-4 mb-5">
																	<span tabIndex={0} className="ms-2 fw-light mt-xl-3 mt-md-3">{edeliveryContent.edelivery_adobe_intro_text} </span>
																	<a href="http://get.adobe.com/reader/" target="_blank" rel="noopener noreferrer">
																		<button tabIndex={0} className="btn btn-download ms-3 fw-semibold downloadadobe">
																			<img src={acrobat} alt="acrobat" />
																			{edeliveryContent.edelivery_adobe_download_btn}
																		</button>
																	</a>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</main> {/*st48236 - 508 compliance*/}
		</>
	);
}
export default Edelivery;